"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setCookie;
function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}